import { Card } from "@/components/ui/card";
import { StepsIndicator } from "./StepsIndicator";
import { LanguageToggle } from "@/components/LanguageToggle";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

interface OnboardingCardProps {
  children: React.ReactNode;
  step: string;
  selectedRole: string;
  onBack?: () => void;
}

export const OnboardingCard = ({ children, step, selectedRole, onBack }: OnboardingCardProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="relative w-full max-w-lg mx-auto px-3 sm:px-4">
      {step !== 'language' && (
        <div className="absolute top-1 right-1 z-10 sm:top-2 sm:right-2">
          <LanguageToggle />
        </div>
      )}
      <Card className="p-3 pt-10 sm:p-4 sm:pt-12 relative min-h-[700px] flex flex-col">
        {step !== 'language' && onBack && (
          <Button
            variant="ghost"
            size="sm"
            className="absolute top-1 left-1 z-10 sm:top-2 sm:left-2"
            onClick={onBack}
          >
            <ChevronLeft className="h-3 w-3 sm:h-4 sm:w-4 mr-1" />
            {t('common.back')}
          </Button>
        )}
        <div className="space-y-3 sm:space-y-4 flex-1">
          {children}
        </div>
        <StepsIndicator currentStep={step} role={selectedRole} />
      </Card>
    </div>
  );
};